const urls = {
  api: '/api',
  local: 'http://localhost', //本地测试
  qec_dev: 'http://qectest.qingec.com', // 腾亿新能源测试
  dp_dev: 'http://test.du-power.com:8085', // 杜普测试
  slxson: 'http://slxson.cross.echosite.cn',
  runcd_dev:'https://ev.tengyiev.com',
  qec:'https://www.qingec.com',
  apiRes: '/apiRes',
  apiMember: '/apiMember',
}

var sysConfig = {
  //配置一些项目级别的配置文件
  // 配置请求前缀,如，在切换环境的时候只需要配置这一处
  apiPre: urls.runcd_dev,
  clientId: 'cbest_pc',
  clientSecret: '123456',
  // cookieKeys
  cookieKeys: {
    tokenKey: 'userToken',
    refreshKey: 'refreshKey'
  },
  // sessionStorage keys
  sessionStorageKeys: {
    jwtToken: 'jwtToken' //存jwt令牌的负载部分
  },
  // 用户信息
  userInfoKeys: {
    userInfo: 'userInfo',
    userTypes: {
      sp_admin: 'SP_ADMIN',
      admin: 'ADMIN',
      consumer: 'CONSUMER',
      pot_operator: 'POTENTIAL_OPERATOR',
      operator: 'OPERATOR',
      group: 'GROUP',
      station: 'STATION'
    }
  }
}

module.exports = sysConfig




//////////////////
// WEBPACK FOOTER
// ./config/sysConfig.js
// module id = kspH
// module chunks = 42